// Libraries
var React = require('react');

// Styles
require('./MatchTable.scss');

class MatchTableModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			countries: this.props.data && this.props.data.Countries ? this.props.data.Countries : [],
			match: this.props.data && this.props.data.Match ? this.props.data.Match : [],
			selectedCountry: "GB",
		};
	}

	componentDidMount() {
		fetch("/api/v1/tv")
			.then( response => {
				if (!response.ok) { throw response }
				return response.json();
			})
			.then( json => {
				var {Countries, Match} = json;
				this.setState({countries: Countries, match: Match});
			})
			.catch( err => {
				console.log(err);
			});
	}

	change(event) {
		this.setState({
			selectedCountry: event.target.value,
		});
	}

	render() {
		return this.state.match.length > 0 ? (
			<React.Fragment>
				<div className="country-select__wrapper">
					<span className="country-select--title">Spurs on TV</span>

					<div className="country-select--select-wrapper">
						<select className="country-select--select" onChange={ (e) => this.change(e) } value={this.state.selectedCountry}>
							{this.state.countries.map(country =>
								<option key={country.Country} value={country.Country}>{country.Name}</option>
							)};
						</select>
						<div className="clearfix"></div>
					</div>
				</div>
				<div className="match-table__container">
					<table>
						<thead>
							<tr>
								<th className="LeagueTable__cell">{'Date'}</th>
								<th className="LeagueTable__cell">Competition</th>
								<th className="LeagueTable__cell">Opposition</th>
								<th className="LeagueTable__cell hide">Venue</th>
								<th className="LeagueTable__cell">KO <span className="no-mobile">Time</span></th>
								<th className="LeagueTable__cell">Channel</th>
							</tr>
						</thead>
						<tbody>
							{this.state.match.map((match, index) =>
								<tr className="LeagueTable__row" key={index}>
									<td className="LeagueTable__cell">{match.KickoffDate}</td>
									<td className="LeagueTable__cell">{match.Competition}</td>
									<td className="LeagueTable__cell">{match.Game}</td>
									<td className="LeagueTable__cell hide">Away</td>
									<td className="LeagueTable__cell ">{match.KickoffTime}</td>
									<td className="LeagueTable__cell ">{match
											.Channels
											.filter(channel => channel.Country === this.state.selectedCountry)
											.map((channel, index) =>
												<span key={index}>{channel.Name}</span>
											)}
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</React.Fragment>
		) : <div></div>
	}
}

module.exports = MatchTableModule;



// WEBPACK FOOTER //
// ./src/components/MatchTable/MatchTableModule.js